<template functional>
  <component
    :is="props.tag"
    :class="data.class"
    class="event-list grid grid-gap-20"
  >
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: 'ul',
    },
  },
};
</script>

<style scoped>
/*
 * The track minimum is 0 rather than auto. An auto minimum sizes every track to the widest
 * card's min-content, so a single card carrying an unbreakable word — the sharer's email
 * address — pushed the whole list wider than a phone screen and the page scrolled sideways.
 */
.event-list {
  grid-template-columns: repeat(auto-fit, minmax(0, 450px));
}

@screen laptop-l {
  .event-list {
    grid-template-columns: repeat(auto-fit, minmax(0, 500px));
  }
}

@screen 4k {
  .event-list {
    grid-template-columns: repeat(auto-fit, minmax(0, 600px));
  }
}
</style>
